import { template } from "@ember/template-compiler";
import { type TOC } from '@ember/component/template-only';
import { concat, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import type { WithBoundArgs } from '@glint/template';
import { t } from 'ember-intl';
import type { ModelListItem } from 'parog-web/components/model-list';
import type Protocol from 'parog-web/models/protocol';
import PauseOkChimioButton from './protocol-section/pause-ok-chimio-button/index';
import PauseProtocolSection from './protocol-section/pause-protocol-section/index';
interface TrashItemSignature {
    Args: {
        item: ModelListItem;
    };
}
const TrashItem: TOC<TrashItemSignature> = template(`
  <i
    class='trash icon opacity-40'
    role='button'
    {{on 'click' @item.destroy}}
  ></i>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export interface ProtocolSectionArgs {
    protocolModel: Protocol;
    item: ModelListItem;
}
interface ProtocolSectionSignature {
    Element: HTMLDivElement;
    Args: ProtocolSectionArgs;
    Blocks: {
        headerActions: [{
                TrashItem: WithBoundArgs<typeof TrashItem, 'item'>;
                PauseOkChimioButton: WithBoundArgs<typeof PauseOkChimioButton, 'preTreatmentSynthesisRoute'>;
            }];
        content: [{
                PauseProtocolSection: WithBoundArgs<typeof PauseProtocolSection, 'changeset' | 'onChangesetUpdate' | 'isProtocolPaused'>;
            }];
    };
}
const TreatmentHistoryProtocolUtilsProtocolSectionComponent: TOC<ProtocolSectionSignature> = template(`
    <div
      class='ui segment'
      data-test-protocol-section={{@protocolModel.protocol}}
    >
      <div>
        <h3 class='ui dividing header'>{{t
            (concat 'treatment-protocol.' @protocolModel.protocol)
          }}</h3>
        <div class='absolute right-0 top-0 mr-2 mt-4'>
          {{yield
            (hash
              TrashItem=(component TrashItem item=@item)
              PauseOkChimioButton=(component
                PauseOkChimioButton protocolModel=@protocolModel
              )
            )
            to='headerActions'
          }}
        </div>
      </div>
      <div>
        {{#if @protocolModel.isPaused}}
          <div
            class='placeholder-label mb-2 p-1'
            data-test-current-treatment-is-paused-message
          >
            Le traitement est actuellement en pause. Veuillez entrer la
            prochaine date de cure pour reprendre.
          </div>
        {{/if}}

        {{yield (hash PauseProtocolSection=PauseProtocolSection) to='content'}}

      </div>
    </div>
  `, {
    eval () {
        return eval(arguments[0]);
    }
});
export default TreatmentHistoryProtocolUtilsProtocolSectionComponent;
